import React, { useEffect } from 'react';
import { Tabs, Card, Button, Row, Col, Collapse } from 'antd';
import styles from './../../index.module.css';
import DetailItem from './../../../CSIComponents/DetailItem';
import PageContainer from '../../../CSIComponents/PageContainer';

const { TabPane } = Tabs;
const { Panel } = Collapse;
const AttractionLocationView = (props: any) => {
  let locations: any = props?.locationData.length > 0 ? props?.locationData : [{ lid: '0', transportation: [{ type: '', charge: '' }] }]
  useEffect(() => {
    if (locations.length > 0) {
      locations.forEach((item: { transportation: { type: string; charge: string; }[]; }) => {
        if (item?.transportation?.length === 0) {
          item.transportation.push({ type: '', charge: '' })
        }
      })
    }
  }, [])
  const edit = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <div style={{ margin: '0 10px 0 0' }}>
          <Button type='primary' className="db-edit-btn" onClick={() => props.setCurrentFlag('table')}>Back</Button>
        </div>
        <div>
          <Button type='primary'className="db-edit-btn" onClick={() => { props.setCurrentFlag('edit') }}>Edit</Button>
        </div>
      </div>
    )
  }
  return (<PageContainer>
    <Card style={{marginTop:-15}}>
      <Tabs defaultActiveKey="Location1" type="card" tabBarExtraContent={edit()}>
        {locations.map((locationData: any, index: any) => {
          return (
            <TabPane tab={'Location' + (index + 1)} key={index}>
              <Row gutter={24}>
                <Col span={6} className={styles.colMargin}>
                  <DetailItem value={locationData.direction} label='Direction' />
                </Col>
                <Col span={6} className={styles.colMargin}>
                  <DetailItem value={locationData.distance} label='Distance' />
                </Col>
                <Col span={6} className={styles.colMargin}>
                  <DetailItem value={locationData.uom} label='Unit Of Measure' />
                </Col>
                <Col span={5}></Col>
                <Col span={6} className={styles.colMargin}>
                  <DetailItem value={locationData.toorfrom} label='To or From' />
                </Col>
                <Col span={6} className={styles.colMargin}>
                  <DetailItem value={locationData.travelmins} label='Travel Time Minutes' />
                </Col>
                <Col span={6} className={styles.colMargin}>
                  <DetailItem value={locationData.desc} label='Direction Description' />
                </Col>
                <Col span={5}></Col>
                <Col span={6} className={styles.colMargin}>
                  <DetailItem value={locationData.latitude} label='Latitude' />
                </Col>
                <Col span={6} className={styles.colMargin}>
                  <DetailItem value={locationData.longitude} label='Longitude' />
                </Col>
                <Col span={6} className={styles.colMargin}>
                  <DetailItem value={locationData.accuracy} label='Geocode Accuracy' />
                </Col>
                <Col span={5}></Col>
                <Col span={6} className={styles.colMargin}>
                  <DetailItem value={locationData.country} label='Country' />
                </Col>
                <Col span={6} className={styles.colMargin}>
                  <DetailItem value={locationData.state} label='State' />
                </Col>
                <Col span={5}></Col>
              </Row>

              <Collapse defaultActiveKey={['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10']} ghost>
                {
                  locationData?.transportation && locationData.transportation.map((item: any, i: number) => (
                    <Panel className="panel-border" header={`Transportation ${i + 1}`} key={i}>
                      <Row gutter={24}>
                        <Col span={6}>
                          <DetailItem value={item.type} label="Transportation Type"></DetailItem>
                        </Col>
                        <Col span={6}>
                          <DetailItem value={item.charge} label="Transportation Charge"></DetailItem>
                        </Col>
                      </Row>
                    </Panel>
                  ))
                }
              </Collapse>
            </TabPane>
          )
        })}
      </Tabs>
    </Card></PageContainer>
  )
}
export default AttractionLocationView;
